import React from "react";
type SectionHeadProps = {
  kicker: string;
  title: string;
  subtitle: string;
};
export function SectionHead({
  kicker,
  title,
  subtitle
}: SectionHeadProps) {
  return <div className="head" data-id="element-139" data-mp="23npxu9avayhe">
      <span className="kick" data-id="element-140" data-mp="28kgfh12bm24x">✦ {kicker}</span>
      <h2 className="h2" data-id="element-141" data-mp="28joknsgjs8fp">{title}</h2>
      <p className="sub" data-id="element-142" data-mp="2cmbge4gcadi6">{subtitle}</p>
    </div>;
}